import { render, staticRenderFns } from "./dictsListTableHead.vue?vue&type=template&id=05890920&scoped=true&"
import script from "./dictsListTableHead.vue?vue&type=script&lang=js&"
export * from "./dictsListTableHead.vue?vue&type=script&lang=js&"
import style0 from "./dictsListTableHead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dictsListTableHead.vue?vue&type=style&index=1&id=05890920&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05890920",
  null
  
)

export default component.exports